// Settings › Communication › E-mail › Sent mail (owner: communication; moved from Settings › Jobs).
import { createFileRoute } from '@tanstack/react-router';
import { SentMailPage } from '../../../features/comm-settings/SentMailPage';

export const Route = createFileRoute('/_settings/settings/mail-log')({ component: SentMailPage });
